export default {
  ar() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date} If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'To finalize your hotel stay, please provide the information below.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'Save',
      updateFailed: 'We could not update you hotel information. Please contact us if the problem continues.'
    }
  },
  de() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'Um Ihren Hotelaufenthalt abzuschließen, geben Sie bitte die untenstehenden Informationen an.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'Save',
      updateFailed: 'We could not update you hotel information. Please contact us if the problem continues.'
    }
  },
  en() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'To finalize your hotel stay, please provide the information below.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'Save',
      updateFailed: 'We could not update you hotel information. Please contact us if the problem continues.'
    }
  },
  enGB() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'To finalize your hotel stay, please provide the information below.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'Save',
      updateFailed: 'We could not update you hotel information. Please contact us if the problem continues.'
    }
  },
  esMX() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'Para finalizar su reserva de hospedaje, favor de proporcionar la información a continuación.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'Save',
      updateFailed: 'We could not update you hotel information. Please contact us if the problem continues.'
    }
  },
  fr() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'Pour finaliser la réservation de votre hébergement en hôtel, veuillez renseigner les informations ci-dessous.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'Enregistrer',
      updateFailed: 'We could not update you hotel information. Please contact us if the problem continues.'
    }
  },
  it() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'To finalize your hotel stay, please provide the information below.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'Salva'
    }
  },
  ja() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'To finalize your hotel stay, please provide the information below.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'セーブ'
    }
  },
  pl() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: 'aby dokończyć rezerwację hotelu, proszę podać poniższe dane.',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: 'zapisz'
    }
  },
  zhCN() {
    return {
      confirmation: {
        deadline:'<strong>Important!</strong> In order to finalize your hotel stay, please fill out the information below by {date}. If This information is not filled out by {date}, your room will be forfeited.',
        deadlineLocation: 'This information can be found on your order details page as well.',
        hotelDetails: 'Hotel Details'
      },
      deadline: '<strong>Important:</strong> Information must be received no later than {date} or your room will be forfeited.',
      details: 'Hotel Reservation Details',
      finalize: '请提供以下信息确定酒店住宿',
      numAdults: 'Number of Adults:',
      requiredDetails: 'Required Hotel Reservation Details',
      resName: 'Name for Reservation:',
      roomNum: 'Room {number}:',
      save: '保存'
    }
  }
}
